import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard/general', { replace: true });
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 p-6">
      <div className="w-full max-w-lg rounded-2xl bg-white dark:bg-boxdark p-10 text-center shadow-2xl">
        {/* 🌀 Ícono decorativo */}
        <div className="mb-6 flex items-center justify-center">
          <div className="flex h-20 w-20 animate-pulse items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/40">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-blue-500 dark:text-blue-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              />
            </svg>
          </div>
        </div>

        {/* 🧭 Título principal */}
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
          Página No Encontrada
        </h1>

        {/* 💬 Descripción */}
        <p className="mt-3 text-base leading-relaxed text-gray-600 dark:text-gray-300">
          Lo sentimos, la página que estás buscando no existe o fue movida.
          <br />
          Verifica la dirección o regresa al panel principal.
        </p>

        {/* Línea decorativa */}
        <div className="mx-auto mb-6 mt-6 h-[2px] w-24 rounded-full bg-blue-500/70" />

        {/* 🔘 Botón volver */}
        <button
          onClick={handleGoHome}
          className="inline-flex items-center justify-center gap-2 rounded-lg 
            bg-blue-600 px-6 py-3 font-semibold text-white shadow-lg 
            transition-all duration-200 hover:bg-blue-700 hover:shadow-xl"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          <span>Volver al Inicio</span>
        </button>

        {/* Footer */}
        <p className="mt-6 text-xs text-gray-400 dark:text-gray-500">
          © {new Date().getFullYear()} Codenova POS — Todos los derechos reservados
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
